<template>
  <BasePopup ref="popup" class="doc-sort">
    <ul class="doc-sort__list">
      <li
        v-for="opt in sortView.options"
        :key="opt.name"
        class="doc-sort__item"
        :class="sortView.activeOptionClass(opt)"
        @click="sortView.optionClick(opt)"
      >
        <span class="doc-sort__title"
          ><span class="doc-sort__icon iconfont" :class="opt.icon"></span
          >{{ opt.name }}</span
        >
      </li>
    </ul>

    <template #buttons>
      <AppButton
        class="doc-sort__btn"
        :big="true"
        @click="sortView.applySort()"
      >
        Apply
      </AppButton>
    </template>
  </BasePopup>
</template>

<script setup lang="ts">
import { onBeforeMount, ref, useTemplateRef } from 'vue'

import type { DocsView } from '@/models/doc'
import { DocsSortMobileView as DocsSortView } from '@/models/docs.sort'
import { emitter } from '@/services/mitt'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'

const props = defineProps<{
  view: DocsView
}>()

const popup = useTemplateRef('popup')
const sortView = ref(new DocsSortView(props.view, hide))

onBeforeMount(async () => {
  emitter.on('openSortPopup', () => {
    popup.value?.show()
  })
})

function hide(): void {
  popup.value?.hide()
}
</script>

<style lang="scss" scoped>
.doc-sort {
  &__list {
    padding: 0;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    line-height: 20px;
    color: $c-black-3;
    border-bottom: 1px solid $c-border;
    padding-bottom: 16px;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
      border: none;
      padding: 0;
    }
    &:after {
      display: inline-block;
      content: '';
      width: 24px;
      height: 24px;
      background-image: url('@/assets.app/images/check.svg');
      background-size: 100% 100%;
      position: relative;
      top: -1px;
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }
    &--active {
      &:after {
        opacity: 1;
      }
    }
  }

  &__icon {
    font-size: 24px;
    margin-right: 8px;
    position: relative;
    top: -1px;
  }

  :deep(.popup__buttons) {
    padding-top: 20px;
    border-top: 1px solid $c-border-2;
  }

  &__btn {
    max-width: 327px;
    font-size: 18px;
  }
}

.night-mode .doc-sort {
  &__item {
    color: $c-white;
    border-color: $c-dark-5;
  }
}
</style>
